export const SET_ONBOARD = 'SET_ONBOARD'
export const SET_BASICID = 'SET_BASICID'
export const SET_FIRMID = 'SET_FIRMID'
export const SET_SHIPID = 'SET_SHIPID'
export const SET_DISABLE = 'SET_DISABLE'
export const SET_TESTMODE = 'SET_TESTMODE'
export const RESET_PAYMENTMETHOD = 'RESET_PAYMENTMETHOD'
export const PREP_ONBOARD = 'PREP_ONBOARD'
export const SET_FIRM_ONBOARD = 'SET_FIRM_ONBOARD'



// WEBPACK FOOTER //
// ./src/store/modules/onboard/types.js